import {LOADER_TYPES} from '../../consts/loader/loaderTypes';
import loaderService from '../loader/loaderService';
import log from '../logger/log';
import notificationService from '../notificationService';
import localizationCountryService from './localizationCountryService';
import localizationDataService from './localizationDataService';
import localizationLanguageService from './localizationLanguageService';

const showLocalizationLoader = () => loaderService.showGlobalLoaderByType({type: LOADER_TYPES.LOCALIZATION_LOADER});
const hideLocalizationLoader = () => loaderService.hideGlobalLoaderByType({type: LOADER_TYPES.LOCALIZATION_LOADER});

const initializeLocalization = async () => {
    showLocalizationLoader();

    try {
        const countryCode = await localizationCountryService.getUserCountryCode();
        const initialLanguageCode = localizationLanguageService.getUserLanguageCode(countryCode);
        const dictionary = await localizationDataService.getLocalization(countryCode, initialLanguageCode);

        if (dictionary) {
            localizationDataService.setLocalization({countryCode, languageCode: initialLanguageCode, dictionary});
            return;
        }

        const itWasDefaultLanguage = localizationLanguageService.checkIsItDefaultLanguage(
            countryCode,
            initialLanguageCode
        );

        if (itWasDefaultLanguage) {
            throw new Error('Default localization unavailable');
        }

        await localizationDataService.setDefaultLocalizationFromApi();
    } catch (e) {
        log.error('localizationControllerService: Error initializing localization:', e);

        notificationService.showLocalizationError();
        await localizationDataService.setDefaultLocalizationFromCode();
    } finally {
        hideLocalizationLoader();
    }
};

const switchLocalization = async (languageCode) => {
    showLocalizationLoader();

    try {
        const countryCode = localizationCountryService.getUserCountryCodeFromLocalStorage();
        const dictionary = await localizationDataService.getLocalization(countryCode, languageCode);

        if (!dictionary) {
            throw new Error('Dictionary not found');
        }

        localizationDataService.setLocalization({countryCode, languageCode, dictionary});
    } catch (e) {
        log.error('localizationControllerService: Error switching localization:', e);

        notificationService.showLocalizationError();
    }

    hideLocalizationLoader();
};

const fetchLocalizationForSWCache = async () => {
    try {
        const countryCode = localizationCountryService.getUserCountryCodeFromLocalStorage();
        const languageCode = localizationLanguageService.getUserLanguageCode(countryCode);
        const dictionary = await localizationDataService.getLocalization(countryCode, languageCode);

        if (!dictionary) {
            throw new Error('Cache fetch failed');
        }
    } catch (e) {
        log.error('localizationControllerService: Error fetching localization for SW cache:', e);
    }
};

export default {
    switchLocalization,
    initializeLocalization,
    fetchLocalizationForSWCache,
};
